import { Helmet } from 'react-helmet'
// import {PhoneLink} from '../../components/Shared/Links'
import menuEarly from '../../assets/images/nyeEarly.png'
import menuNye from '../../assets/images/nyeMenu.png'
import menuEarlyLink from '../../NYE3cMenu.pdf'
import menuNyeLink from '../../NYE4cMenu.pdf'

export default function NewYears(){
  return (
    <div className="pageStyles nyeNew">
      <Helmet>
        <title>New Year's Eve at Villaggio Grille</title>
        <meta name="description" content="Spend New Year's Eve at Villaggio! With multiple seatings, and a special menu, we will make your year!" />
      </Helmet>


      {/* The early bird seating which is a three course dinner with champagne toast for $65 per person
      and then we have the four course nye dinner which is 4 courses for $100 a person 
      option to add on a wine pairing for $50 a person  */}

      <div className="fullSec nyIntro">
        <div className="introWrap kpWrap">
          <h1>Spend New Year's Eve With Us!</h1>
          <h2>December 31 <span className="dot d1">&middot;</span> 3 Seatings <span className="dot d2">&middot;</span> <br className="rules1" />Reservations Required</h2>
          <p class="instr">Click a menu below to view a larger version</p>
        </div>
      </div>

      <div className="fullSec menuWrap">
        <div className="sectionWrap flexGroup justify-between">
          <div className="item i1">
            <h3><span className="time">5pm</span> Early Seating <span className="dot">&middot;</span> $65</h3> 
            <h4>
              3-Course Dinner + Champagne Toast
            </h4>
            <p>Celebrate Before the Countdown!</p>
            <a href={menuEarlyLink} target="_blank" rel="noreferrer" className="menuImage"><img src={menuEarly} alt="3-Course NYE Menu" /></a>
          </div>
          <div className="item i2">
            <h3><span className="time">7:30 &amp; 9:45</span> Seatings <span className="dot">&middot;</span> $100</h3> 
            <h4>
              4-Course Dinner + Champagne Toast
            </h4>
            <p>Add a Wine Pairing for $50 Per Person</p>
            <a href={menuNyeLink} target="_blank" rel="noreferrer" className="menuImage"><img src={menuNye} alt="4-Course NYE Menu" /></a>
          </div>
        </div>
      </div>
      <div className="col-xs-12"><div className="hr hr-png-1"></div></div>
    </div>
  )
}
